import PortalModeWrapper from './PortalModeWrapper';

export default PortalModeWrapper;
